import { permissionObj } from '../../../../Helpers/permission';
import DeleteModal from '../../../Modals/DeleteModal';
import { TrashOutlineIcon, AddIcon } from '../../../../components/buttons/IconButtons';
import NotInformation from '../../../../components/NotInformation';
import SearchSimple from '../../../../components/SearchSimples/SearchSimple';
import ButtonAction from '../../../../components/buttons/ButtonAction';
import HeadTittle from '../../../../components/HeadTittle';
import RolesPanelLogic from './Functionality/RolesPanelLogic';
import routes from '../../../../Routes/routes';
import CustomExpandableTable from '../../../../components/table/CustomExpandableTable';

/**
 * @Author: Susana Garcia Rodriguez
 * @JobTitle: Frontend - IBL
 * @Email: sgarcia@ibl.mx
 */
const RolesPanel = () => {
    const {
        t,
        DEV,
        handleCheckboxChange,
        deleteRoles,
        setIsAllChecked,
        selectRoleForDelete,
        roleShow,
        setRoleShow,
        setBodyForExport,
        searchElement,
        setSearchElement,
        option,
        rowsPerPage,
        setSearch,
        simpleSearch,
        setSimpleSearch,
        contractorId,
        supplierId,
        setSelectRoleForDelete,
        permission,
        navigate,
        resultsToShow,
        pagination,
        handleRowExpand,
        renderOptionsMenu,
        columns,
        setResultsToShow,
        PrivilegeDetails,
        handleDelete,
        handleDeleteAll
    } = RolesPanelLogic();
    return (
        <>
            <HeadTittle name={'privilage_settings'}>
                {DEV || permission?.includes(permissionObj?.WEB_PRIVILEGE_CREATE) ? (
                    <ButtonAction
                        id='btn_rp_create'
                        name='create'
                        className='btn-icon-add'
                        Icon={AddIcon}
                        disabled={false}
                        onClick={() => {
                            navigate(routes.roles.create);
                        }}
                    />
                ) : null}

                {DEV || permission?.includes(permissionObj?.WEB_PRIVILEGE_DELETE) ? (
                    <ButtonAction
                        id='btn_rp_delete'
                        name='delete'
                        className='btn-icon-delete'
                        disabled={selectRoleForDelete?.length === 0}
                        onClick={() => handleDelete()}
                        Icon={TrashOutlineIcon}
                    />
                ) : null}
            </HeadTittle>
            <SearchSimple
                id={'txt_rp_search_simple'}
                setBodyForExport={setBodyForExport}
                setSearchResults={setResultsToShow}
                searchElement={searchElement}
                setSearchElement={setSearchElement}
                optionTable={option}
                rowsPerPage={rowsPerPage}
                setSearch={setSearch}
                simpleSearch={simpleSearch}
                setSimpleSearch={setSimpleSearch}
                contractorId={contractorId}
                supplierId={supplierId}
            />
            {resultsToShow?.content?.length > 0 ? (
                <>
                    <CustomExpandableTable
                        columns={columns}
                        rows={resultsToShow?.content || []}
                        renderExpandedRow={PrivilegeDetails}
                        renderOptionsMenu={
                          renderOptionsMenu
                        }
                        onRowExpand={handleRowExpand}
                        selectedList={selectRoleForDelete}
                        handleCheckboxChange={handleCheckboxChange}
                        handleDeleteAll={handleDeleteAll}
                        checkbox={DEV || permission?.includes(permissionObj?.WEB_PRIVILEGE_DELETE)}
                    />
                    {pagination()}
                </>
            ) : (
                <NotInformation
                    className={"mt-4"}
                    text={t('you_haven_not_created_any_role_yet')}
                    card={true}
                    showButton={DEV || permission?.includes(permissionObj?.WEB_PRIVILEGE_CREATE)}
                    buttonId={'btn_rp_link_create'}
                    buttonTrans={'create_new_role'}
                    buttonOnclick={() => navigate(routes.roles.create)}
                />
            )}
            <DeleteModal
                show={roleShow}
                onHide={() => setRoleShow(false)}
                onClickFn={() => deleteRoles(selectRoleForDelete)}
                data={selectRoleForDelete}
                title_modal={'Privilege'}
                element_modal={'Privilege'}
                isReset={setSelectRoleForDelete}
                isAllReset={setIsAllChecked}
            />
        </>
    );
};
export default RolesPanel;
